import React, { PropsWithChildren } from 'react';
import ModalFooterBase from 'react-bootstrap/ModalFooter';
import { ModalFooterProps } from './types';
import { Button } from 'app/components';
import classnames from 'classnames';
import classes from 'app/utils/classes';
import { isFunction } from 'lodash';

const ModalFooter: React.FC<PropsWithChildren<ModalFooterProps>> = ({
  children,
  submitBtnText,
  submitBtnDisabled = false,
  cancelBtnText,
  align = 'center',
  className,
  border = false,
  onSubmit,
  onCancel
}) => {
  return (
    <ModalFooterBase
      className={classnames(
        {
          [classes.modal.footer]: true,
          'border-none': !border,
          'mt-24': border,
          [`justify-content-${align}`]: true
        },
        className
      )}
    >
      {children ? (
        children
      ) : (
        <div className="d-flex w-50">
          {cancelBtnText && (
            <Button
              className="flex-1"
              size="lg"
              onClick={() => {
                isFunction(onCancel) && onCancel();
              }}
            >
              {cancelBtnText}
            </Button>
          )}
          {submitBtnText && (
            <Button
              className="flex-1"
              disabled={submitBtnDisabled}
              onClick={() => {
                isFunction(onSubmit) && onSubmit();
              }}
              size="lg"
              variant="main"
            >
              {submitBtnText}
            </Button>
          )}
        </div>
      )}
    </ModalFooterBase>
  );
};

export default ModalFooter;
